import * as React from "react";
import type { SVGProps } from "react";
const SvgDocs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#020F20"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.243 3.757a6 6 0 1 1-8.485 8.486 6 6 0 0 1 8.485-8.486"
    />
    <path
      stroke="#020F20"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.357 5.643a3.333 3.333 0 1 1-4.714 4.714 3.333 3.333 0 0 1 4.714-4.714M5.64 10.36l-1.88 1.88M10.354 5.64l1.886-1.88M3.76 3.76l1.88 1.88M10.36 10.36l1.88 1.88"
    />
  </svg>
);
export default SvgDocs;
